import { useMutation } from "react-query";
import { mailSettingsApi } from "frontend/src/api/mail-settings";
import { notify } from "frontend/src/features/notifications";
import { queryClient } from "frontend/src/domain/query-client";
import { mailSettingsCacheKey } from "./shared";
export var useUpdateMailSettings = function () {
    return useMutation(function (settings) { return mailSettingsApi.update(settings); }, {
        onSuccess: function (settings) {
            queryClient.setQueryData(mailSettingsCacheKey, settings);
            notify({ variant: "success", message: "Настройки почты сохранены." });
        },
        onError: function () {
            notify({
                variant: "error",
                message: "Не удалось сохранить настройки почты.",
            });
        },
    });
};
